<template>
    <div
        class="selection-row"
        :class="{
            'selection-row--has-error': error,
            'selection-row--special': selection.isSpecialType(),
            'selection-row--to-remove': error && error.shouldRemove,
            'selection-row--has-info': error && error.isInfo
        }"
    >
        <div class="selection-row__wrapper">
            <div
                v-if="error"
                class="selection-row__error"
            >
                <i class="icon icon-warning_triangle_filled"/>
                <span class="selection-row__error-message">
                    {{ getErrorMessage(error) }}
                </span>
            </div>
            <EventSummary
                :isLive="event.isOngoing()"
                :startDate="event.date"
                :team1Name="event.team1Name || selection.displayName"
                :team2Name="event.team2Name || ''"
                :viewingOptions="{
                    liveBetting: event.isGoingToBeInLiveBetting || false,
                    liveSound: event.isGoingToHaveLiveAudio || false,
                    liveVideo: event.isGoingToHaveLiveVideo || false,
                    broadcast: broadcasts[event.betRadarId],
                }"
                :liveData="event.liveData"
                :sportId="event.sportId"
            />
        </div>
        <div class="selection-row__controls">
            <i v-if="selection.isSpecialType()" class="icon icon-special" />
            <i
                v-if="isRemovable"
                @click="onRemoveClick"
                class="icon icon-delete"
            />
        </div>
        <div
            class="selection-row__bet"
            :class="statusClass"
        >
            <div class="selection-row__market-box">
                <span
                    v-if="showEventNo && selection.event.eventNo"
                    class="selection-row__system-info"
                >
                    {{ selection.event.eventNo }}
                </span>
                <span class="selection-row__fix-switch">
                    <slot />
                </span>
                <span
                    class="selection-row__market-name"
                    :title="selection.name"
                >
                    {{ selection.name }}
                </span>
            </div>
            <Pick
                v-if="selection.odd"
                :id="selection.getOddId()"
                :eventId="selection.getEventId()"
                :value="selection.getOddValue()"
                :symbol="selection.getOddSymbol()"
                :isLocked="selection.isLocked()"
                :specialBetValue="selection.isOngoing() ? '' : selection.getOddSpecialBetValue()"
                :valueChangeDynamics="oddValueDynamics[selection.getEventId()]
                    && oddValueDynamics[selection.getEventId()][selection.getOddId()]"
            />
        </div>
    </div>
</template>

<script>
    import Pick from '@modules/shared/event/Pick.vue';
    import BetSlipHelper from '@store/modules/ui/shared/betSlip/Helpers';
    import EventSummary from '@modules/shared/event/EventSummary.vue';
    import { EventStatus } from '@core/models/tickets/enums';

    export default {
        name: 'Selection',
        props: {
            selection: {
                type: Object,
                required: true
            },
            error: {
                type: Object,
                required: false,
            },
            broadcasts: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            isRemovable: {
                type: Boolean,
                required: false,
                default: true
            },
            showEventNo: {
                type: Boolean,
                required: false,
                default: false
            },
            oddValueDynamics: {
                type: Object,
                required: false,
            },
        },
        methods: {
            getErrorMessage(error) {
                return this.$t(
                    BetSlipHelper.getBetSlipErrorMessageTemplate(error),
                    error.params
                );
            },
            onRemoveClick() {
                this.$emit('removeClick', this.selection);
            },
        },
        computed: {
            event() {
                return this.selection.event;
            },
            statusClass() {
                switch (this.selection.event.status) {
                    case EventStatus.win:
                        return 'selection-row__bet--won';
                    case EventStatus.lost:
                        return 'selection-row__bet--lost';
                    case EventStatus.refund:
                        return 'selection-row__bet--refund';
                    default:
                        return '';
                }
            }
        },
        components: {
            Pick,
            EventSummary,
        },
    };
</script>

<style>
    .error {
        font-size: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/Selection.vue